import {
  PrimaryButton,
  Select,
  TextArea,
  TextField,
} from "@graffer-inc/console-design-kit";
import { NoticeRequest } from "../../../pages/ttzk-portal/notices-create";
import { useState } from "react";
import {
  NoticeValidationErrors,
  NoticeValidator,
} from "../../../../application/domain/ttzk-portal/util/notice-validation";

export type NoticeFormProps = {
  initialNotice: NoticeRequest;
  onSave: (notice: NoticeRequest) => void;
  submitLabel: string;
};

export const NoticeForm = (props: NoticeFormProps) => {
  const [notice, setNotice] = useState<NoticeRequest>(props.initialNotice);

  return (
    <>
      <div className="field">
        <TextField
          label={"タイトル"}
          placeholder={""}
          value={notice.title}
          description={
            "お知らせ情報のタイトルを設定します。タイトルは50文字以内で記載してください。"
          }
          required={true}
          onChange={(e) => {
            setNotice({ ...notice, title: e.target.value });
          }}
          errorMessages={
            NoticeValidator.title(notice.title)
              ? []
              : NoticeValidationErrors.title
          }
        />
      </div>
      <div className="field">
        <TextArea
          onChange={(e) => {
            setNotice({ ...notice, content: e.target.value });
          }}
          label={"お知らせの本文"}
          rows={20}
          placeholder={""}
          required={true}
          value={notice.content}
          errorMessages={
            NoticeValidator.content(notice.content)
              ? []
              : NoticeValidationErrors.content
          }
          description={
            "お知らせ情報の本文を設定します。HTMLタグは利用できませんが、本文中にURLが記載されている場合、当該URLについては自動でリンクに変換されます。"
          }
        />
      </div>
      <div className="field">
        <Select
          label={"お知らせの強調表示"}
          value={notice.isHighlighted ? "1" : "0"}
          description={
            "お知らせ情報の強調表示をONにすると、このお知らせの内容をポータルのトップページに掲載します。" +
            "お知らせの強調表示を設定できるお知らせは1つだけです。" +
            "そのため、このお知らせの強調表示をONにすると、他に強調表示が設定されているお知らせは自動的にOFFになります。"
          }
          options={[
            { name: "ON", value: "1" },
            { name: "OFF", value: "0" },
          ]}
          required={true}
          onChange={(e) => {
            setNotice({ ...notice, isHighlighted: e === "1" });
          }}
        />
      </div>
      <div className="field">
        <label htmlFor={"publishDate"} className={"label"}>
          公開日時 &nbsp;
          <small className={"has-text-danger"}>必須</small>
        </label>
        <input
          required={true}
          name={"publishDate"}
          type={"datetime-local"}
          className={"input"}
          value={notice.publishDate}
          onChange={(e) => {
            setNotice({ ...notice, publishDate: e.target.value });
          }}
        />
      </div>
      <div className="field">
        <Select
          label={"公開設定"}
          value={notice.isPublished ? "1" : "0"}
          description={
            "お知らせ情報の公開設定を設定します。" +
            "公開設定を「公開日時を過ぎたら公開する」に設定すると、公開日時を過ぎたら自動的に公開されます。" +
            "公開設定を「下書き状態のままにする」に設定すると、公開日時を過ぎても公開されません。"
          }
          options={[
            { name: "下書き状態のままにする", value: "0" },
            { name: "公開日時を過ぎたら公開する", value: "1" },
          ]}
          required={true}
          onChange={(e) => {
            setNotice({ ...notice, isPublished: e === "1" });
          }}
        />
      </div>
      <br />
      <div className="field">
        <PrimaryButton
          text={props.submitLabel}
          onClick={() => props.onSave(notice)}
          disabled={!NoticeValidator.isValid(notice)}
        />
      </div>
    </>
  );
};
